import { AsyncSelect, SelectInstance, SelectOption } from '@cimplico/components';
import { Ref, useState } from 'react';
import { useProcedureCategories } from '../../queries/use-procedure-categories';

type ProcedureCategorySelectProps = {
    defaultCategory?: string;
    templateId: string;
    title?: string;
    isOptional?: boolean;
    isMulti?: boolean;
    placeholder?: string;
    form?: string;
    errorMessage?: string;
    isDisabled?: boolean;
    onChange: (ids: string[]) => void;
    innerRef?: Ref<SelectInstance>;
};

function ProcedureCategorySelect({
    defaultCategory,
    templateId,
    title,
    isMulti = false,
    isOptional = false,
    placeholder,
    form,
    onChange,
    isDisabled,
    errorMessage,
    innerRef,
}: ProcedureCategorySelectProps): JSX.Element {
    const [categorySearch, setCategorySearch] = useState('');
    const [selected, setSelected] = useState(defaultCategory ? [defaultCategory] : []);
    const categoryQuery = useProcedureCategories(templateId, { search: categorySearch });

    function handleCategoryChange(options: SelectOption[]): void {
        setSelected(options.map((o) => o.value as string));
        onChange(options.map((o) => o.value as string));
    }

    return (
        <AsyncSelect
            placeholder={placeholder || 'Select a category...'}
            title={title}
            form={form}
            isOptional={isOptional}
            isMulti={isMulti}
            isDisabled={isDisabled}
            errorMessage={errorMessage}
            isLoading={categoryQuery.isFetching || categoryQuery.isLoading}
            options={(categoryQuery.data?.procedureCategories || []).map((i) => ({
                value: i.id,
                label: i.name,
                isSelected: selected.includes(i.id),
            }))}
            onSearch={setCategorySearch}
            onChange={(options): void => {
                handleCategoryChange(options);
            }}
            ref={innerRef}
        />
    );
}

export default ProcedureCategorySelect;
